/*
 * ===============================================================================================================
 *                                Copyright 2025 - 2025, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { useDispatch, useSelector } from 'react-redux';
import { TextField, Grid, IconButton, Tooltip } from '@mui/material';
import { Trash, Search } from '@jda/lui-common-icon-library-mui5';
import { useStyles } from '../../../shared/PolicyDialog/styles';
import LuiMultiSelectCustom from '../../../shared/LuiMultiSelectCustom';
import { compareByProperty } from '../../../utility/commonUtility';
import {
  DISPLAY_NAME,
  SELECT_ALL,
  DIMENSION_ATTRIBUTE_ACTION_TITLE,
  DELETE,
  NO_RECORDS_IN_SEARCH,
  ATTRIBUTE_NAME
} from '../../../shared/PolicyDialog/constants';
import {
  selectDimensionPolicyData
} from '../../../store/role/policyDimension/dimensionSelector';
import { setDimensionPolicyData } from '../../../store/role/policyDimension/dimensionActionCreator';
import { Autocomplete } from '@mui/material';


export const DimensionAttribute = (props: any) => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const { attribute, index, actions, dimensionAttributes } = props;
  const dimensionPolicyData = useSelector(selectDimensionPolicyData);

  const onSelectAttribute = (_event: React.ChangeEvent<any>, value: any) => {
    const attributesArray = dimensionPolicyData.attributes.map((attr: any, i: number) => {
      if (i === index) {
        return {
          ...attr,
          attribute: value
        };
      } else {
        return attr;
      }
    });
    dispatch(setDimensionPolicyData('attributes', attributesArray));
  };

  const onSelectionChange = (name: string, index: number, event: { target: { name: string; value: any } }) => {
    const updatedAttributes = dimensionPolicyData.attributes.map((attr: any, i: number) => {
      if (i === index) {
        return {
          ...attr,
          [name]: event.target.value
        };
      } else {
        return attr;
      }
    });

    dispatch(setDimensionPolicyData('attributes', updatedAttributes));
  };

  const handleRowDelete = (index: number) => {
    const attributeArr = dimensionPolicyData.attributes.filter((_attr: any, i: number) => i !== index);
    dispatch(setDimensionPolicyData('attributes', attributeArr));
  };

  return (
    <Grid container alignItems="flex-end" justifyContent="space-between">
      <Grid item xs={5} className={classes.formStyleAutoComplete}>
        <Autocomplete
          aria-controls={`DimensionAttributes-${index}`}
          id={`${index}`}
          options={dimensionAttributes}
          noOptionsText={NO_RECORDS_IN_SEARCH}
          getOptionLabel={(option: any) => option.displayName}

          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={ATTRIBUTE_NAME}
              placeholder="Search Attribute Name"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <>
                    <Search fontSize="small" className={classes.searchIcon} /> {params.InputProps.startAdornment}
                  </>
                )
              }}
            />
          )}
          onChange={onSelectAttribute}
          value={attribute.attribute}
          ListboxProps={{ id: `DimensionAttributes-${index}` }}
        />
      </Grid>
      <Grid item xs={5} className={classes.formStyle}>
        <LuiMultiSelectCustom
          id={`attribute-value-action-multi-select-${index}`}
          itemData={actions.sort(compareByProperty(DISPLAY_NAME))}
          itemKey="id"
          itemDisplayName={DISPLAY_NAME}
          inputLabel={DIMENSION_ATTRIBUTE_ACTION_TITLE}
          selectedItems={attribute?.attributeAction || []}
          selectAll
          selectAllDisplayText={SELECT_ALL}
          onSelectionChange={(e: any) =>
            onSelectionChange('attributeAction', index, { target: { name: '', value: e } })
          }
        />
      </Grid>
      <Grid item xs={1} className={classes.deleteIcon}>
        <Tooltip id="attribute-icon-button-tooltip" title={DELETE}>
          <IconButton
            id="attribute-icon-button"
            aria-label="delete"
            onClick={() => handleRowDelete(index)}
          >
            <Trash />
          </IconButton>
        </Tooltip>
      </Grid>
    </Grid>
  );
};
